import { Text } from "@chakra-ui/react";
import { parseISO, isAfter } from "date-fns";
import { useLocale } from "#app/context/LocaleContext.jsx";
import { formatFullDateTime } from "#app/utils/dateFormat.js";

export const GoLiveDate = ({ site, ...props }) => {
  if (!site) {
    return null;
  }

  const goLiveDate = site.extraAttributes?.goLiveDate;

  if (!goLiveDate) {
    return null;
  }

  const date = parseISO(goLiveDate);

  if (isAfter(new Date(), date)) {
    return null;
  }

  const locale = useLocale();
  let dateText;

  if (Intl.DateTimeFormat) {
    const dtf = new Intl.DateTimeFormat(locale, {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      timeZoneName: "short",
    });

    dateText = dtf.format(date);
  } else {
    dateText = formatFullDateTime(date, locale);
  }

  return (
    <Text
      color="warning"
      fontSize="sm"
      {...props}
      data-testid="go-live-date"
      suppressHydrationWarning={true}
    >
      Launch: {dateText}
    </Text>
  );
};
